// extracted by mini-css-extract-plugin
export default {"welcomeTitle":"welcomeTitle__neW56","wrapper":"wrapper__zqM+-","content":"content__sC4Yf","welcomeDesc":"welcomeDesc__6nLmy","welcomeButton":"welcomeButton__I5aIw"};